export default __webpack_public_path__ + "static/media/Shapes_25.061a6372.png";